module.exports = __webpack_public_path__ + "static/kitty-ann-53ecd0c45ece537b9ef7db645982092a.gif";